export enum ColumnType {
  Collection = "collection",
  Floor = "floor",
  FloorChange = "floorChange",
  TopOffer = "topOffer",
  Sales = "sales",
  Owners = "owners",
  Volume = "volume",
  FloorChart = "floor chart",
}
